const rpArgsMvp = (contrato, totRecibido, saldoPendiente, claseServSig) => {
  let mayorValPag = 0
  if(saldoPendiente>=0){
    mayorValPag = totRecibido - saldoPendiente
  }else{
    mayorValPag = totRecibido
  }
  let argsUpd = {
    // "idMovClientes": "0",
    "contrato": contrato,
    "codigoServicio": "MAYPAG",
    "nombreResumido": "Mayor valor pagado",
    "descripcionServicio": "Mayor valor pagado",
    "descrClaseServ": claseServSig,
    "concepto": "Mayor valor pagado",
    "periodo": "",
    "valorTotal": mayorValPag,
    "valorRecibido": mayorValPag,
    "numeroOdeDX": 0,
    "procesado": "S",
  }

  return argsUpd
}

export default rpArgsMvp
